var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppButton',{attrs:{"text":""},on:{"click":function($event){return _vm.copy()}}},[_c('AppIcon',{attrs:{"icon":"copy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }